// Generated by scripts/caption_videos.py — performance videos with auto-generated captions.
export const VIDEO_CAPTIONS = {"love-like-this": true, "shaun-escoffery": true, "finally": true, "killing-me-softly": true};
